import { __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useLink } from '@react-aria/link';
import { useRef } from 'react';
import Loader from '../../components/Loader';
import { Wrapper } from './styles';
/**
 *
 * Displays a Button styled as text (what would typically be an Anchor tag)
 * For accessibility reasons, clickable text without an href should be a button, not an anchor.
 *
 */
const TextButton = (_a) => {
    var { children, className, isDisabled, isLoading, onClick, size, textColor, type, weight, hideUnderline = false } = _a, props = __rest(_a, ["children", "className", "isDisabled", "isLoading", "onClick", "size", "textColor", "type", "weight", "hideUnderline"]);
    const ref = useRef(null);
    const { linkProps } = useLink(Object.assign({ onPress: onClick, isDisabled: isDisabled || isLoading }, props), ref);
    const color = textColor || 'textButton';
    return (_jsx(Wrapper, Object.assign({ className: className, "$size": size, "$textColor": color, type: type !== null && type !== void 0 ? type : 'button', disabled: isDisabled, "$isLoading": isLoading, "$hideUnderline": hideUnderline, "$weight": weight, ref: ref }, linkProps, { children: isLoading ? (_jsxs(_Fragment, { children: [_jsx(Loader, { color: color }), children] })) : (children) })));
};
export default TextButton;
//# sourceMappingURL=index.js.map